<template>
  <el-dialog :visible.sync="show" title="时间段计费模型" :before-close="closeDialog" width="800px" :close-on-click-modal="false" append-to-body>
    <div class="" v-loading="loading">
      <el-form label-width="200px" :inline="true" :disabled="isDisabled" :rules="rules" ref="form" :model="form">
        <el-form-item label="计费模型名称" prop="Name">
          <el-input class="input-small" placeholder="请输入计费模型名称" v-model="form.Name"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input class="input-small" placeholder="请输入备注" v-model="form.remark"></el-input><br>{{ form.ext_remark }}
        </el-form-item>
        <div class="flex flex-column flex-a-c">
          <div class="mb-10">
            <span>（尖）</span>
            电费：<el-input-number v-model="form.tipFee" :min="0" :precision="4"></el-input-number>&nbsp;元&nbsp;&nbsp;&nbsp;&nbsp;服务费：<el-input-number v-model="form.tipServeFee" :min="0" :precision="4"></el-input-number>&nbsp;元
          </div>
          <div class="mb-10">
            <span>（峰）</span>
            电费：<el-input-number v-model="form.peakFee" :min="0" :precision="4"></el-input-number>&nbsp;元&nbsp;&nbsp;&nbsp;&nbsp;服务费：<el-input-number v-model="form.peakServeFee" :min="0" :precision="4"></el-input-number>&nbsp;元
          </div>
          <div class="mb-10">
            <span>（平）</span>
            电费：<el-input-number v-model="form.flatFee" :min="0" :precision="4"></el-input-number>&nbsp;元&nbsp;&nbsp;&nbsp;&nbsp;服务费：<el-input-number v-model="form.flatServeFee" :min="0" :precision="4"></el-input-number>&nbsp;元
          </div>
          <div class="mb-10">
            <span>（谷）</span>
            电费：<el-input-number v-model="form.valleyFee" :min="0" :precision="4"></el-input-number>&nbsp;元&nbsp;&nbsp;&nbsp;&nbsp;服务费：<el-input-number v-model="form.valleyServeFee" :min="0" :precision="4"></el-input-number>&nbsp;元
          </div>
        </div>
        <el-table border :data="timeList">
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column label="时间段" prop="timeRange">
            <template slot-scope="{ row }"> {{ row.startTime }}-{{ row.endTime }} </template>
          </el-table-column>
          <el-table-column label="开始时间" prop="startTime">
            <template slot-scope="scope">
              <el-time-select
                :disabled="scope.$index == 0"
                @change="onTimeChange"
                :clearable="false"
                class="input-mini"
                v-model="scope.row.startTime"
                :picker-options="{
                  start: '00:00',
                  step: '00:30',
                  end: '23:59'
                }"
                placeholder="选择时间"
              >
              </el-time-select>
            </template>
          </el-table-column>
          <el-table-column label="时段">
            <template slot-scope="{ row }">
              <el-select v-model="row.model">
                <el-option v-for="(item, index) in modelList" :label="item" :value="item" :key="index"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-plus" @click="addTime">添加</el-button>
              <el-button type="text" icon="el-icon-delete" @click="deleteTime(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="billingModel != 'powersite' && form.send_log">
          <h3>最近发送结果</h3>
          <div>发送时间：{{ form.send_log?.create_time }}</div>
          <div>返回时间：{{ form.send_log?.reply_time }}</div>
          <div>设备返回：{{ form.send_log?.reply_result == 10 ? "成功" : "失败" }}</div>
        </div>
        <div class="flex-end mt-10">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="warning" v-if="billingModel != 'powersite'" @click="submitModel(1)">立即下发</el-button>
          <el-button type="primary" @click="submitModel(0)">保存</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { Push_BrandBox_ChargingConfig, Get_BrandBox_ChargingConfigById, Save_BrandBox_ChargingConfig, Push_FeeTable_ChargingConfig, Get_FeeTable_ChargingConfigById, Save_FeeTable_ChargingConfig } from "@/api/dev_arch_brancdbox.js"
import { Push_PowerSite_ChargingConfig, Get_PowerSite_ChargingConfigById, Save_PowerSite_ChargingConfig } from "@/api/dev_arch_powersite.js"

import { formatDate } from "@/utils/tools.js"
export default {
  data() {
    return {
      timeList: [
        {
          startTime: "00:00",
          endTime: "07:00",
          model: "谷"
        },
        {
          startTime: "07:00",
          endTime: "11:00",
          model: "平"
        },
        {
          startTime: "11:00",
          endTime: "14:00",
          model: "峰"
        },
        {
          startTime: "14:00",
          endTime: "18:00",
          model: "平"
        },
        {
          startTime: "18:00",
          endTime: "23:00",
          model: "尖"
        },
        {
          startTime: "23:00",
          endTime: "00:00",
          model: "谷"
        }
      ],
      rules: {
        Name: [{ required: true, message: "请填写计费模型名称", trigger: "change" }]
      },
      modelList: ["尖", "峰", "平", "谷"],
      form: {
        Name: "",
        remark: "",
        tipFee: "",
        tipServeFee: "",
        peakFee: "",
        peakServeFee: "",
        flatFee: "",
        flatServeFee: "",
        valleyFee: "",
        valleyServeFee: "",
        ext_remark:""
      },
      loading: false,
      isDisabled: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // type: {
    //   type: String,
    //   default: ""
    // },
    billingModel: {
      type: String
    }
  },
  watch: {
    show(val) {
      if (val && (this.params.charging_config_id > 0||this.params.triplet_id>0)) {
        this.getModelDetail()
      } else {
        this.isDisabled = false
      }
    }
  },
  methods: {
    getModelDetail() {
      this.loading = true
      if (this.billingModel == "brandbox") {
        Get_BrandBox_ChargingConfigById({
          Id: this.params.charging_config_id,
          triplet_id:this.params.triplet_id
        })
          .then((res) => {
            this.getModelDetail_after(res)
            this.isDisabled = false
          })
          .finally(() => {
            this.loading = false
          })
      } else if (this.billingModel == "powersite") {
        Get_PowerSite_ChargingConfigById({
          Id: this.params.charging_config_id
        })
          .then((res) => {
            this.getModelDetail_after(res)
            this.isDisabled = false
          })
          .finally(() => {
            this.loading = false
          })
      } else if (this.billingModel == "feeTable") {
        
        Get_FeeTable_ChargingConfigById({
          Id: this.params.charging_config_id,
          triplet_id:this.params.triplet_id
        })
          .then((res) => {
            this.getModelDetail_after(res)
            this.isDisabled = false
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    getModelDetail_after(res) {
      if (!res || !res.data) {
        return
      }
      let _form = res.data
      let _model = res.data.Config
      this.form = {
        ModelId: _form.ModelId,
        Name: _form.Name,
        remark: _form.CDesc,
        tipFee: _form.tipfee,
        tipServeFee: _form.tipservefee,
        peakFee: _form.peakfee,
        peakServeFee: _form.peakservefee,
        flatFee: _form.flatfee,
        flatServeFee: _form.flatservefee,
        valleyFee: _form.valleyfee,
        valleyServeFee: _form.valleyservefee,
        send_log: _form.send_log,
        ext_remark:_form.ext_remark,
      }
      console.log("2222222222222222",_model)
      if(_model&&_model.length>0)
      {
        this.timeList = _model.map((item) => {
          return {
            startTime: item.time,
            endTime: "00:00",
            model: item.typename
          }
        })
      }
      this.onTimeChange()
    },
    onTimeChange() {
      let _timeList = this.timeList
      for (let i = 0, len = _timeList.length; i < len; i++) {
        _timeList[i].endTime = i + 1 == len ? "00:00" : _timeList[i + 1].startTime
      }
    },
    submitModel(type) {
   
      this.$refs.form.validate((valid) => {
        if (valid) {
          let checkTime = true
          for (var i = 0; i < this.timeList.length; i++) {
            if (this.timeList.length - 1 != i) {
              let now = formatDate(new Date().getTime(), "yyyy-MM-dd")
              var nowTime = new Date(now + " " + this.timeList[i].startTime).getTime()
              var nextTime = new Date(now + " " + this.timeList[i + 1].startTime).getTime()
              if (nextTime <= nowTime) {
                checkTime = false
                break
              }
            }
          }
          if (!checkTime) {
            this.$message.error("跨时间段!")
            return
          }

          let _timeList = JSON.parse(JSON.stringify(this.timeList))
          let modelArr = []
          _timeList.forEach((item) => {
            let fee = 0
            let feeserver = 0
            switch (item.model) {
              case "尖":
                fee = this.form.tipFee
                feeserver = this.form.tipServeFee
                break
              case "峰":
                fee = this.form.peakFee
                feeserver = this.form.peakServeFee
                break
              case "平":
                fee = this.form.flatFee
                feeserver = this.form.flatServeFee
                break
              case "谷":
                fee = this.form.valleyFee
                feeserver = this.form.valleyServeFee
                break
            }
            modelArr.push({
              time: item.startTime,
              typename: item.model,
              fee: fee.toFixed(4),
              feeserver: feeserver.toFixed(4)
            })
          })
          // for (let i = 0; i < modelArr.length; i++) {
          //   if (modelArr[i].fee == 0) {
          //     this.$message.error(`${modelArr[i].typename}电费不能为0`);
          //     return;
          //   }
          // }

          let req = {
            //dto: JSON.stringify({
            power_branch_box_id: this.params.power_branch_box_id,
            Name: this.form.Name,
            ModelId: this.form.ModelId,
            CDesc: this.form.remark,
            tipfee: this.form.tipFee.toFixed(4),
            peakfee: this.form.peakFee.toFixed(4),
            flatfee: this.form.flatFee.toFixed(4),
            valleyfee: this.form.valleyFee.toFixed(4),
            tipservefee: this.form.tipServeFee.toFixed(4),
            peakservefee: this.form.peakServeFee.toFixed(4),
            flatservefee: this.form.flatServeFee.toFixed(4),
            valleyservefee: this.form.valleyServeFee.toFixed(4),
            config: modelArr
            //})
          }
          if (type == 0) {
            this.SaveChargingConfig(req)
          } else if (type == 1) {
            this.PushChargingConfig(req)
          }
        } else {
        }
      })
    },
    SaveChargingConfig(data) {
      const loading = this.$loading()
      if (this.billingModel == "brandbox") {
        Save_BrandBox_ChargingConfig(data)
          .then((res) => {
            this.$emit("confirm", res.Id)
            this.closeDialog()
          })
          .finally(() => {
            this.$message.success("保存成功")
            loading.close()
          })
      } else if (this.billingModel == "powersite") {
        data.power_site_id = this.params.power_site_id
        Save_PowerSite_ChargingConfig(data)
          .then((res) => {
            this.$emit("confirm", res.Id)
            this.closeDialog()
          })
          .finally(() => {
            this.$message.success("保存成功")

            loading.close()
          })
      } else if (this.billingModel == "feeTable") {
        data.power_branch_box_feeTable_id = this.params.power_branch_box_feeTable_id
        Save_FeeTable_ChargingConfig(data)
          .then((res) => {
            this.$emit("confirm", res.Id)
            this.closeDialog()
          })
          .finally(() => {
            this.$message.success("保存成功")

            loading.close()
          })
      }
    },
    PushChargingConfig(data) {
      const loading = this.$loading()
      if (this.billingModel == "brandbox") {
        Push_BrandBox_ChargingConfig(data)
          .then((res) => {
            this.$emit("confirm", res.Id)
            this.closeDialog()
          })
          .finally(() => {
            loading.close()
          })
      } else if (this.billingModel == "powersite") {
        data.power_site_id = this.params.power_site_id
        Push_PowerSite_ChargingConfig(data)
          .then((res) => {
            this.$emit("confirm", res.Id)
            this.closeDialog()
          })
          .finally(() => {
            loading.close()
          })
      } else if (this.billingModel == "feeTable") {
        data.power_branch_box_feeTable_id = this.params.power_branch_box_feeTable_id
        Push_FeeTable_ChargingConfig(data)
          .then((res) => {
            this.$emit("confirm", res.Id)
            this.closeDialog()
          })
          .finally(() => {
            loading.close()
          })
      }
    },
    addTime() {
      if (this.timeList.length >= 10) {
        this.$message.warning("最多只能添加10个时间段")
        return
      }
      this.timeList.push({
        startTime: "00:00",
        endTime: "00:00",
        model: "尖"
      })
    },
    deleteTime(index) {
      if (this.timeList.length == 1) return this.$message.warning("至少保留一个时间段")
      this.timeList.splice(index, 1)
      this.onTimeChange()
    },
    closeDialog() {
      //清空表单数据
      for (let key in this.form) {
        this.form[key] = ""
      }
      if (this.timeList.length == 0) {
        this.timeList = [
          {
            startTime: "00:00",
            endTime: "07:00",
            model: "谷"
          },
          {
            startTime: "07:00",
            endTime: "11:00",
            model: "平"
          },
          {
            startTime: "11:00",
            endTime: "14:00",
            model: "峰"
          },
          {
            startTime: "14:00",
            endTime: "18:00",
            model: "平"
          },
          {
            startTime: "18:00",
            endTime: "23:00",
            model: "尖"
          },
          {
            startTime: "23:00",
            endTime: "00:00",
            model: "谷"
          }
        ]
      }
      this.$emit("update:show", false)
    }
  }
}
</script>
